import {Controller} from "stimulus";
import {URLSearchParams} from "core-js/modules/web.url-search-params";

export default class extends Controller {

    static targets = ['submitButton', 'form']

    connect() {
        const controller = this;

        addEventListener('submit', async function (e) {
            e.preventDefault();
            if (e.target && e.target.name === controller.formTarget.name) {
                controller.submitButtonTarget.setAttribute('disabled', 'disabled');
                const url = controller.element.dataset.url;

                const formData = new FormData(controller.formTarget);
                const query = new URLSearchParams(formData).toString();

                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: query
                })

                const {output, isValid} = await response.json();

                if (isValid) {
                    controller.formTarget.submit();
                }else{
                    controller.element.innerHTML = output;
                    controller.submitButtonTarget.removeAttribute('disabled');
                }


            }

        });
    }
}